<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات بنر"
        >
          <b-form
            ref="bannerform"
            @submit.prevent
          >
            <b-row>
              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col
                    class="image"
                    cols="12"
                  >
                    <fm-file-select v-model="Form.Media" label="عکس" :entity="1" />
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        name="Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="جایگاه"
                      label-for="BannerPositionId"
                    >
                      <z-banner-position v-model="Form.BannerPositionId" />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="متن دکمه"
                      label-for="CallToAction"
                    >
                      <b-form-input
                        id="CallToAction"
                        v-model="Form.CallToAction"
                        name="CallToAction"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="لینک"
                      label-for="Uri"
                    >
                      <b-form-input
                        id="Uri"
                        v-model="Form.Uri"
                        autocomplete="off"
                        name="Uri"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="وضعیت"
                      label-for="IsActive"
                    >
                      <v-select
                        v-model="Form.IsActive"
                        :options="enums('IsActive')"
                        dir="rtl"
                        label="text"
                        :clearable="false"
                        :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group
                        label="الویت"
                        label-for="Sort"
                    >
                      <b-form-input
                          id="Sort"
                          v-model="Form.Sort"
                          autocomplete="off"
                          type="number"
                          name="Sort"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group
                        label="نسخه"
                        label-for="BuildNumber"
                    >
                      <b-form-input
                          id="BuildNumber"
                          v-model="Form.BuildNumber"
                          autocomplete="off"
                          type="number"
                          name="BuildNumber"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group
                        label="تاریخ شروع"
                        label-for="StartDate"
                    >
                      <date-picker
                          v-model="Form.StartDate"
                          placeholder=""
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group
                        label="تاریخ پایان"
                        label-for="EndDate"
                    >
                      <date-picker
                          v-model="Form.EndDate"
                          placeholder=""
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group
                        label="محدودیت بازدید"
                        label-for="Sort"
                    >
                      <b-form-input
                          id="MaxVisit"
                          v-model="Form.MaxVisit"
                          autocomplete="off"
                          type="number"
                          name="MaxVisit"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group
                        label="محدودیت کلیک"
                        label-for="MaxClick"
                    >
                      <b-form-input
                          id="MaxClick"
                          v-model="Form.MaxClick"
                          autocomplete="off"
                          type="number"
                          name="MaxClick"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                        label="کاربران هدف"
                        label-for="SegmentId"
                    >
                      <selectSegmentCustom
                          v-model="Form.SegmentId"
                          :multiple="false"
                          :clearable="true"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZBannerPosition from '@/tools/bannerposition.vue'
import selectSegmentCustom from '@/tools/selectSegmentCustom.vue'
import FmFileSelect from "@/views/menu/file-manager/components/fmFileSelect.vue"

export default {
  name: 'BannerDetails',
  components: {
    ZBannerPosition,
    selectSegmentCustom,
    FmFileSelect
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Media: null,
        Url: null,
        Sort: 0,
        BannerPositionId: null,
        CallToAction: null,
        IsVideo: false,
        IsActive: true,
        StartDate: null,
        EndDate: null,
        SegmentId: null
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.banner.add
      if (this.$route.params.id) {
        url = this.$api.banner.update
      }

      this.loading = true
      this.$http.post(url, this.Form)
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.banner.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
          this.Form.Media = res.data.FileInfo.FilePath
        })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
